import { Badge, LinkOpenIcon } from '@thefarmersfront/kitchen';

import type { ColDef, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';

import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';
import { CLAIM_RETURN_COURIER_STATUS_BADGE_COLOR, type TypeClaimReturnCourierStatus } from '~/constants/claim';

import type { TypeReturnDetailData } from '~/types/claim.types';

type TypeReturnOrderTracking = NonNullable<TypeReturnDetailData['returnOrderTrackings']>[number];

/**
 * [반품 신청/조회] 신청 상세 모달 > '회수 송장 정보' 테이블 컬럼 정의
 */
const getClaimReturnDetailTrackingColumnDefs = () => {
  const columnDefs: ColDef<TypeReturnOrderTracking>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'invoiceNumber',
      headerName: '회수 송장번호',
      width: 130,
    },
    {
      field: 'status',
      headerName: '송장상태',
      cellDataType: false,
      width: 100,
      cellRenderer: Badge,
      cellRendererParams: ({
        value,
      }: ICellRendererParams<TypeReturnOrderTracking, TypeReturnOrderTracking['status']>) => ({
        variant: 'light',
        status: true,
        color: CLAIM_RETURN_COURIER_STATUS_BADGE_COLOR[value?.code as TypeClaimReturnCourierStatus],
        children: value?.name,
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'invoiceTrackingUrl',
      headerName: '',
      width: 95,
      cellRenderer: TextButtonCell,
      cellRendererParams: ({
        value,
      }: ICellRendererParams<TypeReturnOrderTracking, TypeReturnOrderTracking['invoiceTrackingUrl']>) => ({
        children: '배송조회',
        size: 'tiny',
        target: '_blank',
        href: value,
        rightIcon: <LinkOpenIcon size={16} color="#672091" />,
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'failureReason',
      headerName: '회수 실패사유',
      minWidth: 335,
      flex: 1,
      valueGetter: ({ data }: ValueGetterParams<TypeReturnOrderTracking, TypeReturnOrderTracking['failureReason']>) =>
        data?.failureReason ?? '-',
    },
    {
      field: 'statusAt',
      headerName: '최종 업데이트일시',
      width: 159,
      valueFormatter: ({ value }: ValueFormatterParams<TypeReturnOrderTracking, TypeReturnOrderTracking['statusAt']>) =>
        formatDate(value, DATE_FORMAT.DATE_TIME) ?? '-',
    },
  ];

  return { columnDefs };
};

export default getClaimReturnDetailTrackingColumnDefs;
